module.exports = __webpack_public_path__ + "static/media/dj.af3a950a.jpeg";